import { useIntl } from 'react-intl';
import FilePicker from '@rio-cloud/rio-uikit/FilePicker';
import { AegFormSectionProps } from '../../../../../../models/newAEG';

const AttachmentsSection = ({ values, errors, requiredFields, onChange }: AegFormSectionProps) => {
    const intl = useIntl();

    return (
        <section className='border rounded padding-15'>
            <h3 className='display-flex align-items-center gap-x-2 margin-top-0 margin-bottom-15 text-size-16 text-bold'>
                <span className='rounded-circle bg-primary text-color-white text-size-12 width-25 height-25 inline-flex items-center justify-center shrink-0'>
                    5
                </span>
                {intl.formatMessage({ id: 'intl-msg:support.aeg.newRequest.section.attachments' })}
                {requiredFields.includes('attachments') && <span className='text-color-danger'>*</span>}
            </h3>
            <FilePicker
                displayMode='dropzone'
                multiple
                onPick={files => onChange('attachments', [...values.attachments, ...Array.from(files ?? [])])}
            >
                {() => (
                    <div className='rounded border border-style-dashed border-color-gray bg-lightest text-center text-color-darker padding-25 cursor-pointer'>
                        <span className='rioglyph rioglyph-files text-size-200pct opacity-50' />
                        <div className='margin-top-10 text-size-14 text-medium'>
                            {intl.formatMessage({ id: 'intl-msg:support.aeg.newRequest.attachments.dropzone' })}
                        </div>
                        <div className='text-size-12 text-color-gray'>
                            {intl.formatMessage({ id: 'intl-msg:support.aeg.newRequest.attachments.hint' })}
                        </div>
                    </div>
                )}
            </FilePicker>
            {values.attachments.length > 0 && (
                <ul className='list-unstyled margin-top-10 margin-bottom-0 text-size-12'>
                    {values.attachments.map((file, index) => (
                        <li key={`${file.name}-${index}`}>
                            <span className='rioglyph rioglyph-file margin-right-5' />
                            {file.name}
                        </li>
                    ))}
                </ul>
            )}
            {errors.attachments && (
                <span className='text-size-12 text-color-danger'>
                    {intl.formatMessage({ id: 'intl-msg:support.custom.fieldRequired' })}
                </span>
            )}
        </section>
    );
};

export default AttachmentsSection;
